import React from 'react';

import { Card, Box, Text } from 'wix-style-react';
import ChevronRight from 'wix-ui-icons-common/ChevronRight';

import { datahooks } from '../constants';
import { InjectedTranslateProps, translate } from 'react-i18next';

export interface ToolCardProps extends InjectedTranslateProps {
  toolName: string;
  onClick(): void;
}

export const ToolCardComponent: React.FC<ToolCardProps> = (props) => {
  const { toolName, t } = props;
  return (
    <Card>
      <div
        data-hook={datahooks.toolClickableWrapper(toolName)}
        onClick={props.onClick}
        style={{ cursor: 'pointer' }}
      >
        <Box height="60px" direction="vertical" padding="24px">
          <Box>
            <Text weight="bold" dataHook={`tool-card-${toolName}-title`}>
              {t(`crmHomePage.toolCard.${toolName}Title`)}
            </Text>
            <ChevronRight color="#3899ec" />
          </Box>
          <Text
            size="small"
            weight="thin"
            secondary
            dataHook={`tool-card-${toolName}-subtitle`}
          >
            {t(`crmHomePage.toolCard.${toolName}Subtitle`)}
          </Text>
        </Box>
      </div>
    </Card>
  );
};

export const ToolCard = translate()(ToolCardComponent);
